export default {"src":"/_next/static/media/chevron-down-black.4033ae10.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};